import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// hooks
import { usePosthogCapture } from 'eCoach/posthogCapture/formFilling';

// components
import ChatBubble from 'eCoach/ChatBubble';
import ClickableInput from 'eCoach/ClickableInput';

// styles
import * as StyledPromptControls from 'eCoach/_styles/PromptControls.style';

interface WarningLetterTypeInputProps {
  sendUserInput: (text: string, type: number) => void;
  inputType: number;
}

export default function WarningLetterTypeInput({
  sendUserInput,
  inputType,
}: WarningLetterTypeInputProps): JSX.Element {
  const { t } = useTranslation('pageEcoach');
  const formFilling = usePosthogCapture();

  const onCustomerComplaintsClick = useCallback(() => {
    sendUserInput(t('Customer Complaints'), inputType);
    formFilling.warningLetterSelectedCustomerComplaints();
  }, [inputType, formFilling, sendUserInput, t]);

  const onUnprofessionalBehaviorClick = useCallback(() => {
    sendUserInput(t('Unprofessional Behavior'), inputType);
    formFilling.warningLetterSelectedUnprofessionalBehaviour();
  }, [inputType, formFilling, sendUserInput, t]);

  const onAttendanceClick = useCallback(() => {
    sendUserInput(t('Attendance'), inputType);
    formFilling.warningLetterSelectedAttendance();
  }, [inputType, formFilling, sendUserInput, t]);

  return (
    <ChatBubble sentByUser>
      <StyledPromptControls.ButtonsColumn>
        <ClickableInput
          inputAction={onCustomerComplaintsClick}
          inputText={t('Customer Complaints')}
          inputType="light"
        />
        <ClickableInput
          inputAction={onUnprofessionalBehaviorClick}
          inputText={t('Unprofessional Behavior')}
          inputType="light"
        />
        <ClickableInput
          inputAction={onAttendanceClick}
          inputText={t('Attendance')}
          inputType="light"
        />
      </StyledPromptControls.ButtonsColumn>
    </ChatBubble>
  );
}
